import { default as NextImage } from 'next/image';

export const Image = ({
  src,
  ...rest
}: React.ComponentProps<typeof NextImage>) => (
  <NextImage
    src={
      typeof src === 'string'
        ? src.indexOf('http') === 0
          ? src
          : `/phonics${src}`
        : src
    }
    {...rest}
  />
);
